import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { BoxModule } from "../box";
import { FlexBoxModule } from "../flex-box";
import { ButtonComponentModule } from "../forms";
import { HeaderTabsComponentModule } from "../header-tabs";
import { LinkModule } from "../link";
import { SidebarComponentModule } from "../sidebar";
import { TooltipModule } from "../utils";
import { IconModule } from "../utils/icon";
import { PageBodyComponent } from "./page-body.component";
import { PageContainerComponent } from "./page-container.component";
import { PageDividerComponent } from "./page-divider.component";
import { PageHeaderComponent } from "./page-header.component";

@NgModule({
  imports: [
    CommonModule,
    BoxModule,
    SidebarComponentModule,
    FlexBoxModule,
    HeaderTabsComponentModule,
    ButtonComponentModule,
    IconModule,
    TooltipModule,
    LinkModule
  ],
  declarations: [
    PageBodyComponent,
    PageContainerComponent,
    PageDividerComponent,
    PageHeaderComponent
  ],
  exports: [
    PageBodyComponent,
    PageContainerComponent,
    PageDividerComponent,
    PageHeaderComponent
  ]
})
export class PageContainerComponentModule {}
